<template>
  <Section :title="gettext('Votre commune de résidence')">
    <FormGroup :field="field" :errors="errors">
      <div class="grid grid--large grid--multiline">
        <div class="grid__item sm-w-1/3 md-w-1/4">
          <Input
            v-model="tempValue"
            maxlength="4"
            inputmode="numeric"
            pattern="[0-9]*"
          />
        </div>

        <div v-if="simulation.location" class="grid__item sm-w-2/3 md-w-3/4">
          <div
            v-if="
              simulation.location.isAvailable &&
              !city &&
              simulation.cityIndex !== 0
            "
          >
            <FormGroup :field="cityField" hide-label>
              <RadiosList
                :value="simulation.cityIndex"
                @change="
                  (val) => updateSimulation({ cityIndex: val.target.value })
                "
              />
            </FormGroup>
          </div>
          <Alert v-else-if="simulation.location.isAvailable" type="success">
            <div class="h5 mrgt0 text-success">
              {{ gettext('Commune desservie') }}
            </div>
            <div class="text-medium">
              {{
                interpolate(gettext('%s est desservie par Energiapro.'), [
                  city.cityName,
                ])
              }}
            </div>
          </Alert>
          <Alert v-else type="error">
            <div class="h5 mrgt0 text-error">
              {{ gettext('Commune non desservie') }}
            </div>
            <div class="text-medium">
              {{
                gettext(
                  'Ce lieu n’est actuellement pas desservi par Energiapro. Le service client vous renseigne au 0800 429 429.'
                )
              }}
            </div>
          </Alert>
        </div>
      </div>
    </FormGroup>
  </Section>
</template>

<script setup>
import Section from '@/components/simulation/Section.vue';
import FormGroup from '@/components/forms/FormGroup.vue';
import Input from '@/components/forms/fields/Input.vue';
import RadiosList from '@/components/forms/fields/RadiosList.vue';
import Alert from '@/components/ui/Alert.vue';

import useCitySearch from '@/composables/useCitySearch';
import { ref, computed, watch } from 'vue';
import { useSimulation } from '@/composables/useSimulation';

const { simulation, updateSimulation, city } = useSimulation();
const { search, errors } = useCitySearch();

const tempValue = ref(simulation.zipCode);

const field = computed(() => {
  return {
    label: gettext('Code postal'),
    name: 'zip-code',
    required: true,
  };
});

const cityField = computed(() => {
  return {
    label: gettext('Localité'),
    name: 'city',
    required: true,
    choices: simulation.location?.citiesAvailable
      ? simulation.location.citiesAvailable.map((city, index) => {
          return [index, city.cityName];
        })
      : [],
  };
});

watch(tempValue, (value) => {
  const data = {
    zipCode: value,
    location: null,
    cityIndex: null,
  };

  search(value).then(
    (location) => {
      data.location = location.value;
      if (location.value.citiesAvailable?.length === 1) {
        data.cityIndex = 0;
      }
      updateSimulation(data);
    },
    () => {}
  );
});
</script>
